import { CopyButton } from "./Copy";

// A command to run in a terminal, with its Copy beside it: a class's share
// command, an assignment's. The command is its own element, so it is read
// (and selected by hand, one click selecting it) apart from the button.

export function CommandLine({ command }: { command: string }) {
  return (
    <div className="command-line">
      <pre className="command">{command}</pre>
      <CopyButton text={command} />
    </div>
  );
}

/**
 * Commands run in turn — making an exam, publishing a template, putting a
 * file — each to copy, a command broken at its spaces where it must be (the
 * template pages' `ul.commands code`). It was the Exams page's own; shared,
 * it lives with CommandLine (byj-1wv.51.12). A command may carry a note,
 * muted under it and never copied with it (the guide's, byj-1wv.51.22).
 */
export function AuthorCommands({ commands }: { commands: (string | { command: string; note?: string })[] }) {
  return (
    <ul className="commands" data-testid="author-commands">
      {commands.map((item, i) => {
        const { command, note } = typeof item === "string" ? { command: item, note: undefined } : item;
        // one command may be listed twice with different notes
        return (
          <li key={`${i} ${command}`} className="row">
            {note ? (
              <span className="grow command-noted">
                <code>{command}</code>
                <span className="muted small">{note}</span>
              </span>
            ) : (
              <code className="grow">{command}</code>
            )}
            <CopyButton text={command} />
          </li>
        );
      })}
    </ul>
  );
}

/** The command that shares a session with the class, or to one of its assignments (RFC-043 model 19). */
export const shareCommand = (code: string, assignment?: string) => `byj run --share class:${code}${assignment ? `/${assignment}` : ""}`;
